import { render, staticRenderFns } from "./personal-id-card.vue?vue&type=template&id=4d824088&"
import script from "./personal-id-card.vue?vue&type=script&lang=js&"
export * from "./personal-id-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports